import axios from 'axios';
import Cookies from 'js-cookie';
//import Router from 'next/router';
import invariant from 'tiny-invariant';

invariant(
  process.env.REACT_APP_API_ENDPOINT,
  'REACT_APP_PUBLIC_REST_API_ENDPOINT is not defined, please define it in your .env file'
);
const Axios = axios.create({
  baseURL: process.env.REACT_APP_API_ENDPOINT,
  timeout: 50000,
  headers: {
    'Content-Type': 'application/json',
  },
});
// Change request data/error
//const AUTH_TOKEN_KEY = process.env.REACT_APP_PUBLIC_AUTH_TOKEN_KEY ?? 'authToken';
const AUTH_TOKEN_KEY = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxIiwianRpIjoiYWQwYzk0MmU4ZWVhMjQ4MjQ3NzQ1YzYzODc3M2MzZjg3M2UxZjcwYzk4YzI1MjIwYWFmN2Y2Y2Y3YTAxYzZmZGQwYjgwOWE2YTcwMWEzMTciLCJpYXQiOjE2NzUzMTY0MjUuNTI4Njg2LCJuYmYiOjE2NzUzMTY0MjUuNTI4NjkxLCJleHAiOjE3MDY4NTI0MjUuNDQxODAzLCJzdWIiOiIyIiwic2NvcGVzIjpbXX0.G5rC86XnWuWXlLrFq-s-aOq4QNcfyfmcPfYEnl3ryFgk3en00oK0qe4V6tgJg0m-Z6SqxJgbZjNBcygCsfNFRESYK_4Vfh5aHqIss5pbDe_WtVkPV5Bgzo4Wvzj-LNnXNrW8ZQNiHH94z7nnOp9F1CdqVOktjxrAJ0KZj3O2vEEZrtkSVTdLiSIdF_kxQHANIBKtTsb5a5Vwlc0XK-8eWjIIaqQlXjX0X36v3jmK0XiWBBteLn9sa5OhI2RM39N1L2nsDKxD6rHguugNbcR23ruKurUCxEpx-BDRIZ_p3AGfe1QCd5dkCC_pFOQhaPbhFT8MGi-tNNF5Kr-7egVWRgTHf5C9Kz1UMRXqvcXM3FTTEDUa4MbzWlXlCSHWUBeGA8QWYgKL4r9ZHH_AyePlAstjL7asn3TQkrRkLCUHNJ4vluI1AXUiKSnWTB9PyNPOKCtue4Dtz1CVjmg6o3h4D7elNu4WmFGSYoexL9kzBT94-8ELfmVN_JBMYG2t3Px_WyIUq1abwl4SSVklz_XICqz0FaB9EJYR4lUHnNsmS1CPp54vVvD4jqkQ1enQS6G52eOiUZ5lZ_Hx06ASeJ4O2AUnXjy_blxPcLV2HIchVS5AQK91ozfDliCvIhzbjo1RRSzyX8FAPsoqyGC33cUYz7SDty4TOMHO0ih8a6h0uzs';
Axios.interceptors.request.use((config) => {
  const cookies = Cookies.get(AUTH_TOKEN_KEY);
  
  //let token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxIiwianRpIjoiYWQwYzk0MmU4ZWVhMjQ4MjQ3NzQ1YzYzODc3M2MzZjg3M2UxZjcwYzk4YzI1MjIwYWFmN2Y2Y2Y3YTAxYzZmZGQwYjgwOWE2YTcwMWEzMTciLCJpYXQiOjE2NzUzMTY0MjUuNTI4Njg2LCJuYmYiOjE2NzUzMTY0MjUuNTI4NjkxLCJleHAiOjE3MDY4NTI0MjUuNDQxODAzLCJzdWIiOiIyIiwic2NvcGVzIjpbXX0.G5rC86XnWuWXlLrFq-s-aOq4QNcfyfmcPfYEnl3ryFgk3en00oK0qe4V6tgJg0m-Z6SqxJgbZjNBcygCsfNFRESYK_4Vfh5aHqIss5pbDe_WtVkPV5Bgzo4Wvzj-LNnXNrW8ZQNiHH94z7nnOp9F1CdqVOktjxrAJ0KZj3O2vEEZrtkSVTdLiSIdF_kxQHANIBKtTsb5a5Vwlc0XK-8eWjIIaqQlXjX0X36v3jmK0XiWBBteLn9sa5OhI2RM39N1L2nsDKxD6rHguugNbcR23ruKurUCxEpx-BDRIZ_p3AGfe1QCd5dkCC_pFOQhaPbhFT8MGi-tNNF5Kr-7egVWRgTHf5C9Kz1UMRXqvcXM3FTTEDUa4MbzWlXlCSHWUBeGA8QWYgKL4r9ZHH_AyePlAstjL7asn3TQkrRkLCUHNJ4vluI1AXUiKSnWTB9PyNPOKCtue4Dtz1CVjmg6o3h4D7elNu4WmFGSYoexL9kzBT94-8ELfmVN_JBMYG2t3Px_WyIUq1abwl4SSVklz_XICqz0FaB9EJYR4lUHnNsmS1CPp54vVvD4jqkQ1enQS6G52eOiUZ5lZ_Hx06ASeJ4O2AUnXjy_blxPcLV2HIchVS5AQK91ozfDliCvIhzbjo1RRSzyX8FAPsoqyGC33cUYz7SDty4TOMHO0ih8a6h0uzs';
  let token = localStorage.getItem('access_token');
  /*if (cookies) {
    token = JSON.parse(cookies)['token'];
  }
  */
  console.log("TOKEN DYNAMIC ",localStorage.getItem('access_token'));

  config.headers = {
    ...config.headers,
    Authorization: `Bearer ${token}`,
  };
  return config;
});

// Change response data/error here
Axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      (error.response && error.response.status === 401) ||
      (error.response && error.response.status === 403) ||
      (error.response &&
        error.response.data.message === 'PICKBAZAR_ERROR.NOT_AUTHORIZED')
    ) {
      Cookies.remove(AUTH_TOKEN_KEY);
      //Router.reload();
    }
    return Promise.reject(error);
  }
);

function formatBooleanSearchParam(key: string, value: boolean) {
  return value ? `${key}:1` : `${key}:`;
}

interface SearchParamOptions {
  categories: string;
  code: string;
  type: string;
  name: string;
  shop_id: string;
  is_approved: boolean;
  tracking_number: string;
}

export class HttpClientFront {
  static async get(url: string, params?: unknown) {
    const response = await Axios.get(url, { params });
    return response.data;
  }

  static async post(url: string, data: unknown, options?: any) {
    const response = await Axios.post(url, data, options);
    return response.data;
  }

  static async put(url: string, data: unknown) {
    const response = await Axios.put(url, data);
    return response.data;
  }

  static async delete(url: string) {
    const response = await Axios.delete(url);
    return response.data;
  }

  static formatSearchParams(params: Partial<SearchParamOptions>) {
    return Object.entries(params)
      .filter(([, value]) => Boolean(value))
      .map(([k, v]) =>
        ['type', 'categories', 'tags', 'author', 'manufacturer'].includes(k)
          ? `${k}.slug:${v}`
          : ['is_approved'].includes(k)
          ? formatBooleanSearchParam(k, v)
          : `${k}:${v}`
      )
      .join(';');
  }
}

export function getFormErrors(error: unknown) {
  if (axios.isAxiosError(error)) {
    return error.response?.data.message;
  }
  return null;
}

export function getFieldErrors(error: unknown) {
  if (axios.isAxiosError(error)) {
    return error.response?.data.errors;
  }
  return null;
}
